;(function () {
  'use strict'

  angular.module('admin.sync_data.service', []).factory('SyncDataService', SyncDataService)

  /** @ngInject */
  function SyncDataService($http, $q, API) {
    function syncNow() {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/es/re-index/utilities')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    return {
      syncNow: syncNow,
    }
  }
})()
